export default __webpack_public_path__ + "static/media/image27.278c8a03.svg";